<script lang="ts">
import { defineComponent } from 'vue'
import TestModeSelector from '@/components/common/ui/TestModeSelector.vue'
import ExportPanel from '@/components/log/ExportPanel.vue'
import ExportList from '@/components/log/ExportList.vue'

export default defineComponent({
  name: 'LogReport',
  components: {
    TestModeSelector,
    ExportPanel,
    ExportList,
  },
  data() {
    return {
      isTestMode: false,
    }
  },
  computed: {
    appId(): string {
      return this.$route.params.app_id as string
    },
  },
})
</script>

<template>
  <div class="q-mb-sm" style="margin-top: -50px">
    <test-mode-selector v-model="isTestMode" :isHideCopy="true" />
    <div class="horizontal-line q-mt-sm"></div>
  </div>
  <div class="row items-center q-mt-md">
    <div class="col-auto">
      <span class="text-h6 text-bold">{{ $t('label.log_report.page_title') }}</span>
    </div>
    <hr class="col header-line" />
  </div>
  <div class="row column q-gutter-y-md">
    <div class="col">
      <export-panel :app-id="appId" :is-test-mode="isTestMode" />
    </div>
    <div class="col">
      <export-list :app-id="appId" :is-test-mode="isTestMode" />
    </div>
  </div>
</template>

<style scoped>
.header-line {
  border: none;
  border-top: 1px solid #d0d2e0;
  background-color: red;
}
</style>
